module.exports = __webpack_public_path__ + "img/suanli.20a09ffe.png";